<div class="duna-user-catering-preferences">
  <h2 class="heading">Kostpræferencer</h2>
  @if (!accessDenied) { @if (isEditingOtherUser && displayName) {
  <p class="subtitle">Forplejning for {{ displayName }}</p>
  } @if (isOnProfilePage && !isEditingOtherUser) {
  <p class="explanation">
    Dine kostpræferencer bruges automatisk, når du tilføjes til et event med
    forplejning. Du kan stadig vælge andet ved tilmelding til et enkelt event.
  </p>
  } @if (isOnProfilePage && isEditingOtherUser) {
  <p class="explanation">
    Kostpræferencer for {{ displayName || "brugeren" }}. De bruges automatisk,
    når vedkommende tilføjes til et event med forplejning.
  </p>
  } @if (!isOnProfilePage && !isEditingOtherUser) {
  <p class="explanation">
    Disse valg bruges automatisk, når du tilføjes til events med forplejning. Du
    kan stadig vælge andet ved tilmelding til et enkelt event.
  </p>
  } @if (!isOnProfilePage && isEditingOtherUser) {
  <p class="explanation">
    Standard forplejning for denne bruger ved tilmelding til events med
    forplejning.
  </p>
  } } @if (loading) {
  <div class="loading-row">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Henter præferencer...</span>
  </div>
  } @if (!loading && errorMessage) {
  <div class="error">{{ errorMessage }}</div>
  } @if (!loading && !errorMessage) {
  <div class="options">
    @for (option of preferenceOptions; track option) {
    <label class="option">
      <mat-checkbox
        [checked]="isSelected(option.value)"
        (change)="togglePreference(option.value, $event.checked)"
      >
        {{ option.label }}
      </mat-checkbox>
    </label>
    }
  </div>
  } @if (!loading && !errorMessage) {
  <div class="actions">
    <button
      mat-flat-button
      color="primary"
      (click)="save()"
      [disabled]="saving"
    >
      {{ saving ? "Gemmer..." : "Gem kostpræferencer" }}
    </button>
  </div>
  }
</div>
